import React, {useState, useContext, useEffect} from "react";
import { ObjectifPosContain,SelectSectionObjectif} from "@gull";
import { useTranslate } from 'react-redux-multilingual'
import { Redirect,useParams } from "react-router-dom";
import { IsAuthContext } from '../../../app/App';
import axios from 'axios'
import swal from "sweetalert2";

const useLoad = (posid) => {
    const t = useTranslate();
    const [section,setSection]=useState([])
    const { authParam } = useContext(IsAuthContext)
    const modulePos = authParam.modules.find(value=>value.name=='pos')

    useEffect(function () {
        (async function() {
            if(modulePos.params.hasOwnProperty('access_ca_other') && modulePos.params.access_ca_other.active){
                const response = await axios.get(process.env.REACT_APP_API_URL+"api/section"
                ).then((response) => {
                    setSection(response.data.datas)
                }).catch((error) => {
                    if(error=='end_session') return;
                    swal.fire(t('unknowError'), "", "error");
                })
            }
        })()
    }, [])
   
    return [section]
}

const Objectif = (props) => {
    const t = useTranslate();
    const { posid: routePosid } = useParams();
    const posid = props.posid ?? routePosid;
    const { authParam } = useContext(IsAuthContext)
    const [forSection,setForSection] = useState(posid);
    const [showTabsContain,setShowTabsContain]= useState({//ici on va faire en sorte que le contenu d'une tabs ne s'affiche que lorsqu'on clique sur la tabs en question. La tabs par defaut doit être la seule présente dans cette initialisation
        today:true
    })
    const modulePos = authParam.modules.find(value=>value.name=='pos')
    const [section] = useLoad()

    useEffect(function () {
        setForSection(posid)
    }, [posid])

    let isAuthSection = false;
    authParam.sections.forEach(section=>{
        if(section.id==posid){
            isAuthSection=true
        } 
    })

    if(!isAuthSection){
        return <Redirect to={"/welcome/welcome"} />
    }

    return (
        <>
            <>
                {modulePos.params.hasOwnProperty('access_ca_other') && modulePos.params.access_ca_other.active &&
                    <SelectSectionObjectif 
                        forSection={forSection}
                        setForSection={setForSection}
                        setShowTabsContain={setShowTabsContain}
                        sections={section}
                        defaultValue={forSection}
                    />
                }
                <div>
                    <ObjectifPosContain moduleParam={modulePos} from="pos" sectionid={forSection} showTabsContain={showTabsContain} setShowTabsContain={setShowTabsContain} inlineLoad={props.inlineLoad}/>
                </div>
            </>
        </>
    )
}

export default Objectif;
